import { number, string, type, union } from "superstruct";

export const CartItemSchema = type({
    id: union([number(), string()]),
    quantity: number(),
    variant_id: number(),
    product_id: number(),
});
